<!-- <app-topbar *ngIf="!ifNews"></app-topbar>
<router-outlet [ngClass]="ifVideo ? 'cover-space' : ''">
</router-outlet>
<app-footer *ngIf="!ifNews"></app-footer> -->

<app-topbar *ngIf="!ifNews"></app-topbar>
<router-outlet>
</router-outlet>
<app-footer *ngIf="!ifNews"></app-footer>